import { HubTextSection as HubTextSectionType } from 'utils/gloo-types';
import cn from 'classnames';
import Markdown from 'components/atoms/Markdown';
import { HubPreviewView } from 'pages/_AdminAuthoringPages/_components/HubPreview';
import HubSectionDescription from './HubSectionDescription';
import HubSectionTitle from './HubSectionTitle';

export interface HubTextSectionProps {
  hubTextSection: HubTextSectionType;
  previewView?: HubPreviewView;
}

const HubTextSection = ({
  hubTextSection: { title, titleColor, description, descriptionColor, text, textColor },
  previewView,
}: HubTextSectionProps) => (
  <div
    className={cn('m-auto max-w-[1204px] flex flex-col', {
      'gap-5 xl:gap-8': !previewView,
      'gap-8': previewView === HubPreviewView.Desktop,
      'gap-5': previewView === HubPreviewView.Mobile,
    })}
  >
    <div className="flex flex-col gap-2">
      <HubSectionTitle title={title} titleColor={titleColor} />
      <HubSectionDescription description={description} descriptionColor={descriptionColor} />
    </div>
    <div style={{ color: textColor }} className="font-normal text-base leading-relaxed">
      <Markdown defaultStyles={false} content={text} className="md-render" />
    </div>
  </div>
);

export default HubTextSection;
